<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red" style="background-color: #ec5d59 !important;">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">{{ add_month }}月业绩明细</div>
          <div class="money">
            团队:<span class="num">{{ commission }}</span>元<br />
<!--            <span class="num showpvclass">{{ commission_pv }}</span>pv<br />-->
            直推:<span class="num">{{ my_commission }}</span>元
<!--            <span class="num showpvclass">{{ my_commission_pv }}</span>pv-->
<!--
            团队:<span class="num">{{ commission_pv }}</span>元<br />
            直推:<span class="num">{{ my_commission_pv }}</span>元
-->

<!--            总共业绩:<span class="num">{{ commission_pv }}</span>元<br />
            左区业绩:<span class="num">{{ commission_pv_left }}</span>元<br />
            右区业绩:<span class="num">{{ commission_pv_right }}</span>元-->
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record" ref="content">
      <div class="list" v-if="info.length > 0">
          <table cellpadding="5" >
            <thead  class="item">
              <tr class="listn">
                <th align="center" >日期</th>
                <th align="center" >团队</th>
                <th align="center" >直推</th>

<!--                <th align="center" >左区</th>
                <th align="center" >右区</th>-->
                <th align="center" >操作</th>
              </tr>
            </thead>
            <tbody  v-for="(val, index) in info" :key="index" class="item">
                <tr   class="listn listn2">
                  <td align="center">{{val._add_day}}</td>
                  <td align="center">{{val.team_total_price}}<span class="showpvclass">({{val.team_total_pv}}pv)</span></td>
                  <td align="center">{{val.user_total_price}}<span class="showpvclass">({{val.user_total_pv}}pv)</span></td>
                  <td align="center"><router-link  :to="{ path: '/user/income/' + val._add_day }" class="bonus_show">明细</router-link></td>
                </tr>
<!--                <tr   class="listn listn2">
                  <td align="center">{{val._add_day}}</td>
                  &lt;!&ndash;<td align="center">{{val.team_total_pv}}元</td>
                  <td align="center">{{val.user_total_pv}}元</td>&ndash;&gt;
                  <td align="center">{{val.team_total_pv_left}}元</td>
                  <td align="center">{{val.team_total_pv_right}}元</td>
                  <td align="center"><router-link  :to="{ path: '/user/income/' + val._add_day }" class="bonus_show">明细</router-link></td>
                </tr>-->
            </tbody>

          </table>
      </div>

      <div class="shoppingCart">
        <div  style="margin-top:0px;"
              class="noCart"
              v-if="showno === 0"
        >
          <div class="pictrue"><img src="@assets/images/noList.png" /></div>
        </div>
      </div>
    </div>

    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<style>
  .sign-record .list .item .listn th{
    padding:0.15rem 0px;
  }
  .sign-record .list .item .listn .listntime {
    padding-left:0.15rem;
  }
  .sign-record .list .item .listn td{
    padding:0.30rem 0px;
  }
  .sign-record .list .item .listn{
    font-size: 0.28rem;
    color: #282828;

  }
  .sign-record .list .item .listn2{
    border-bottom:1px solid #eee;
  }
  .bonus_show {
    color:#ec5d59;
    font-size:0.3rem;
  }
</style>
<script>
import {  getIncomeListDay } from "../../../api/user";
import Loading from "@components/Loading";
const NAME = "IncomeDay";
export default {
  name: NAME,
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      showno:1,
      info: [],
        allBonus:[],
      commission: 0,
        commission_pv: 0,
        my_commission: 0,
        my_commission_pv: 0,
        allBonusCountCan:2,
      where: {
        page: 1,
        limit: 20,
          add_month:this.$route.params.add_month,
      },
        add_month:this.$route.params.add_month,
      types: 3,
      loaded: false,
      loading: false
    };
  },
    watch: {
        $route(n) {
            if (n.name === NAME) {
                this.commission = 0;
                this.commission_pv = 0;
                this.info = [];
              this.showno=1;
                this.where.add_month = this.$route.params.add_month;
                this.add_month = this.$route.params.add_month;
                this.loaded= false;
                this.loading= false;
                this.where.page = 1;
                this.getIndex();
            }
        }
    },
  mounted: function() {
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
        getIncomeListDay(that.where).then(
        res => {
          that.loading = false;
          that.allBonus = res.data.allBonus;
          that.loaded = res.data.list.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data.list);
          that.commission = res.data.teammoney;
          that.commission_pv = res.data.teampv;
          that.my_commission = res.data.mymoney;
          that.my_commission_pv = res.data.mypv;

          that.commission_pv_left = res.data.teampv_left;
          that.commission_pv_right = res.data.teampv_right;

          if(that.info.length==0){
            that.showno=0;
          }else{
            that.showno=1;
          }
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
